module.exports = __webpack_public_path__ + "img/Puente_Istobal_MWASH3PRO_Alto_Blanco-default-back.1935054b.jpg";